export default __webpack_public_path__ + "static/media/information--road-bump--g1.59ac514a.png";